import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** タイムゾーン */
enum TimeZone {
  cst = 'CST',
  ctt = 'CTT',
  iet = 'IET',
  jst = 'JST',
  pst = 'PST',
  rok = 'ROK',
  utc = 'UTC',
}

const nameConfig = {
  cst: new Map([
    [Locale.ja, '中部標準時'],
    [Locale.en, 'CST'],
  ]),
  ctt: new Map([
    [Locale.ja, '中国標準時'],
    [Locale.en, 'CTT'],
  ]),
  iet: new Map([
    [Locale.ja, '東部標準時'],
    [Locale.en, 'IET'],
  ]),
  jst: new Map([
    [Locale.ja, '日本標準時'],
    [Locale.en, 'JST'],
  ]),
  pst: new Map([
    [Locale.ja, '太平洋標準時'],
    [Locale.en, 'PST'],
  ]),
  rok: new Map([
    [Locale.ja, '韓国標準時'],
    [Locale.en, 'ROK'],
  ]),
  utc: new Map([
    [Locale.ja, '協定世界時'],
    [Locale.en, 'UTC'],
  ]),
};

const toEnum = rawValueToEnum(TimeZone, TimeZone.cst);
const toDisplay = enumToName(TimeZone, nameConfig);
const toDisplayWithPrefix = enumToName(TimeZone, nameConfig, { prefix: true });

export const timeZone = {
  enum: TimeZone,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { TimeZone };
